import { StandingSocketService } from "./standing";

export default new StandingSocketService();
